// Mirror of lib/portalOnly.js for a standalone SuperAdmin service. Set
// REACT_APP_SUPERADMIN_ONLY=true at build time for a deployment that
// should ONLY ever serve the SuperAdmin console — its own Railway
// service, its own domain, sourced from this exact same frontend
// codebase so SuperAdmin pages are never duplicated.
export const isSuperadminOnly = () => process.env.REACT_APP_SUPERADMIN_ONLY === "true";
